// Speaker side: play the received Opus return track to a chosen output device
// (headphones — mandatory, else the talkback feeds back into the mic). Uses a
// bare <audio> element; setSinkId is Chromium-only and feature-guarded.
export type ReturnPlaybackHandle = {
  setSink(deviceId: string): Promise<boolean>; // false if routing to the chosen device failed
  stop(): void;
};

export function startReturnPlayback(stream: MediaStream, sinkDeviceId?: string): ReturnPlaybackHandle {
  const el = new Audio();
  el.srcObject = stream;
  el.autoplay = true;

  async function setSink(deviceId: string): Promise<boolean> {
    if (deviceId && 'setSinkId' in el) {
      try {
        await (el as unknown as { setSinkId: (id: string) => Promise<void> }).setSinkId(deviceId);
        return true;
      } catch (e) {
        console.warn('return playback setSinkId failed', e);
        return false;
      }
    }
    return false;
  }

  if (sinkDeviceId) void setSink(sinkDeviceId);
  void el.play().catch((e) => console.warn('return playback play() failed', e));

  return {
    setSink,
    // Detach the playback element only. The stream's tracks are REMOTE (delivered
    // by the RTCPeerConnection's ontrack); their lifecycle is owned by the PC and
    // released when the speaker closes it in stop() — we must not stop them here.
    stop() {
      el.pause();
      el.srcObject = null;
    },
  };
}
